exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table[data-v-3d6bed6c]{border-collapse:collapse;width:100%}td[data-v-3d6bed6c],th[data-v-3d6bed6c]{border:1px solid #000;padding:5px}.md-direction-bottom-right[data-v-3d6bed6c]{width:18%!important}.center[data-v-3d6bed6c]{text-align:center}.b-form-input-container[data-v-3d6bed6c]{margin:4px 0 12px!important}.activeClass[data-v-3d6bed6c]{display:none}.error[data-v-3d6bed6c]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d6bed6c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/freightForwarding/ffDocListPage.vue
// module id = 1524
// module chunks = 0